<template>
  <div v-click-outside="closeOptionsModal" class="account-options-modal">
    <h1 class="options-title">{{ $t("campaignManager.options") }}</h1>
    <div class="options">
      <button
        class="option-button"
        :class="{ 'disable-button': disableLocalization }"
        :disabled="disableLocalization"
        @click="openLocalizationModal"
      >
        <WorldIcon
          class="edit-icon"
          :class="{ 'disable-icon': disableLocalization }"
        />
        {{ $t("account.userInformation.bottomButtons.localization") }}
      </button>
      <button class="option-button" @click="openDefaultColorsPicker">
        <BrushIcon class="edit-icon brush-icon" />
        {{ $t("account.userInformation.bottomButtons.defaultColors") }}
      </button>
      <button class="option-button" @click="removeWatermark">
        <BubbleIcon class="edit-icon" />
        {{ $t("account.removeWatermark") }}
      </button>
    </div>
  </div>
</template>

<script>
import WorldIcon from "@/assets/svg/world-icon.svg?inline";
import BrushIcon from "@/assets/svg/brush-icon.svg?inline";
import BubbleIcon from "@/assets/svg/settings/bubble-icon.svg?inline";

export default {
  components: {
    WorldIcon,
    BrushIcon,
    BubbleIcon,
  },
  props: {
    disableLocalization: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeOptionsModal() {
      this.$emit("close-options-modal");
    },
    openLocalizationModal() {
      this.$emit("open-localization");
    },
    openDefaultColorsPicker() {
      this.$emit("open-default-colors-picker");
    },
    removeWatermark() {
      this.$emit("remove-watermark");
    },
  },
};
</script>
<style lang="scss" scoped>
.account-options-modal {
  box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.25);
  padding: 16px;
  z-index: 99;
  background: white;
  position: absolute;
  bottom: 110px;
  right: 230px;
  border-radius: 4px;
  border: 1px solid rgb(196, 196, 196);
}
.options-title {
  @include base-font;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  color: $light-grey;
  margin-bottom: 16px;
}
.options {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
}
.option-button {
  @include base-font;
  background: transparent;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  color: $dark-grey;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  position: relative;
  text-align: left;
  &:hover {
    width: 100%;
    background: $dark-purple;
    color: white;
    border-radius: 4px;
    text-align: left;
    .edit-icon path {
      fill: white;
    }
  }
}
.disable-button {
  color: $light-grey;
  &:hover {
    color: $light-grey;
    background: transparent;
    .disable-icon {
      path {
        fill: $light-grey;
      }
    }
  }
}

.disable-icon {
  path {
    fill: $light-grey;
  }
}

.brush-icon {
  path {
    fill: #585858;
  }
}
</style>
